/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import DOMPurify from "dompurify";
import { useDispatch, useSelector } from "react-redux";
import { getSettingApi } from "../../../Features/Setting/Setting";
import PolicyLayout from "./PolicyLayout";

function Refund() {
  const dispatch = useDispatch();
  const setting = useSelector((s) => s.setting?.settingData);

  useEffect(() => {
    dispatch(getSettingApi());
    window.scrollTo(0, 0);
  }, []);

  return (
    <PolicyLayout
      breadcrumb="Returns & Exchanges"
      eyebrow="Customer Care"
      title="Returns & Exchanges"
      intro="Read on for our returns window, condition requirements and how refunds are processed. We want you to feel confident in every purchase."
      htmlBlocks={[
        DOMPurify.sanitize(setting?.app_return_refund_policy || ""),
        DOMPurify.sanitize(setting?.app_cancellation_refund || ""),
      ]}
      fallback="Returns and refund details are being finalised. Please contact us before sending anything back and we'll guide you through the process."
      contactCtaText="Need to start a return or exchange? Get in touch and we'll handle it for you."
    />
  );
}

export default Refund;
